import { IonButton, IonContent } from "@ionic/react";
interface Props {
  setShowModal1: Function;
}
const AssessmentDescription: React.FC<Props> = ({ setShowModal1 }) => {
  return (
    <IonContent placeholder={undefined}>
      <div className="assessment-decription-wrap">
        <h1>Assessment Description</h1>
        <h2>Gait Analysis</h2>
        <div className="space-bar"></div>
        <p>
          Gait analysis is a method for identifying biomechanical abnormalities
          in the gait cycle - in other words it’s a way of assessing the way in
          which you walk and run. <br></br><br></br>
          The Gait Analysis is performed by standing 10 feet away from the
          VSTBalance sensor. A person would simply walk toward the VSTBalance
          at their normal pace.
        </p>
        <IonButton
          className="generic-btn"
          onClick={() => setShowModal1(false)} placeholder={undefined}        >
          Return to Assessments
        </IonButton>
      </div>
    </IonContent>
  );
};
export default AssessmentDescription;
